import { types } from 'mobx-state-tree';

const PreloaderStore = types
  .model('Preloader', {
    loaded: types.optional(types.boolean, false),
  })
  .actions(self => {
    const listeners = [];
    return {
      setLoaded: () => {
        self.loaded = true;
        self.runListeners();
      },

      addListener: listener => {
        listeners.push(listener);
      },

      runListeners: () => {
        listeners.forEach(listener => listener());
      },
    };
  });

export default PreloaderStore;



// WEBPACK FOOTER //
// ./src/stores/PreloaderStore.js